export const newPropertiesStore = [
  {
    ENTITY: "store",
    PROPERTY: "dataSort",
    NAME: "Дата",
    TYPE: "S",
  },
  {
    ENTITY: "store",
    PROPERTY: "payer",
    NAME: "Плательщик",
    TYPE: "S",
  },
  {
    ENTITY: "store",
    PROPERTY: "amount",
    NAME: "Сумма",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "reference",
    NAME: "Наименование операции",
    TYPE: "S",
  },
  {
    ENTITY: "store",
    PROPERTY: "accountId",
    NAME: "Id счета",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "status",
    NAME: "Статус",
    TYPE: "S",
  },
  {
    ENTITY: "store",
    PROPERTY: "deal",
    NAME: "Сделка",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "task",
    NAME: "Задача",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "company",
    NAME: "Компания",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "user",
    NAME: "Пользователь",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "contact",
    NAME: "Контакт",
    TYPE: "N",
  },
  {
    ENTITY: "store",
    PROPERTY: "typeOfPayment",
    NAME: "Форма рассчета",
    TYPE: "S",
  },
];

export const uf = {
  inValuationRubMin:
    "UF_AUTO_125161634609" /** Внутренная оценка в рублях ОТ */,
  inValuationRubMax:
    "UF_AUTO_640515230555" /** Внутренная оценка в рублях ДО */,
  inValuationHoursMin:
    "UF_AUTO_147911261922" /** Внутренная оценка в часах ОТ]  */,
  inValuationHoursMax:
    "UF_AUTO_516922867998" /** Внутренная оценка в рублях ДО */,
  inFactRub: "UF_AUTO_477816195733" /** Внутренний факт в рублях */,
  inPaidRub: "UF_AUTO_953571778604" /** Оплачено, руб. */,
  toPayRub: "UF_AUTO_617658674928" /** Осталось оплатить, руб. */,
  estimatedClosed: "UF_AUTO_230112688666" /** закрытое сметное */,
  planedRemaining: "UF_AUTO_911165766117" /** Плановое оставшееся */,
  activeRemaining: "UF_AUTO_154406438957", // Активные часы
  planDay: "UF_AUTO_315960646288", // план на день
  tarif: "UF_AUTO_282959697790", // тариф
  // dealId: ушло в deal
  deal: {
    // Поля Сделки
    id: "UF_AUTO_209467938737", // ID Сделки
    estimatedClosed: "UF_CRM_1612177676048", // Закрытые сметные часы в Сделке
    estimatedOpen: "UF_CRM_1612177997214", // Оставшиеся сметные часы в в Сделке
    estimatedBuy: "UF_CRM_1612177065", // Приобретенные сметные часы Сделке
    review: "UF_CRM_1380533674", // Результат ревью проекта
  },
  company: {
    id: "UF_AUTO_928941732282", // ID компаниии
    class: "UF_CRM_1506583167", // Класс клиента
  },
};
